import { Plus } from "lucide-react";

interface AddAnotherIngredientButtonProps {
  disabled: boolean;
  onClick: () => void;
  showPendingHint: boolean;
}

const AddAnotherIngredientButton = ({
  disabled,
  onClick,
  showPendingHint
}: AddAnotherIngredientButtonProps) => {
  return (
    <>
      <button
        type="button"
        onClick={onClick}
        disabled={disabled}
        className="tw-w-full tw-rounded-xl tw-border-2 tw-border-dashed tw-border-border tw-p-5 tw-flex tw-flex-col tw-items-center tw-justify-center tw-text-muted-foreground hover:tw-bg-muted/50 hover:tw-text-foreground tw-transition-colors disabled:tw-opacity-50 disabled:tw-cursor-not-allowed disabled:hover:tw-bg-transparent"
        aria-label="Add another ingredient"
      >
        <Plus className="tw-h-6 tw-w-6 tw-mb-2 tw-opacity-50" />
        <span className="tw-text-xs tw-font-semibold tw-uppercase tw-tracking-widest">
          Add Additional Ingredient
        </span>
      </button>
      {showPendingHint ? (
        <p className="tw-text-xs tw-text-muted-foreground">
          Save or remove the pending ingredient before adding another or finishing.
        </p>
      ) : null}
    </>
  );
};

export default AddAnotherIngredientButton;
